var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiscellaneousGrievance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chats",
    transform: "translate(0 0.578)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7113",
    "data-name": "Rectangle 7113",
    width: 22,
    height: 22,
    transform: "translate(0 -0.578)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65023",
    "data-name": "Path 65023",
    d: "M35.339,48.769,32,51.467V40.674A.675.675,0,0,1,32.675,40H43.467a.675.675,0,0,1,.675.674v7.42a.675.675,0,0,1-.675.675Z",
    transform: "translate(-29.302 -36.565)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65024",
    "data-name": "Path 65024",
    d: "M80,92.722v3.373a.674.674,0,0,0,.674.674H88.8l3.339,2.7V88.675A.675.675,0,0,0,91.467,88H88.094",
    transform: "translate(-73.255 -80.518)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscellaneousGrievance);
export default __webpack_public_path__ + "static/media/miscellaneous-grievance.7a217f7cb3156a2c6e0a8185951db5e6.svg";
export { ForwardRef as ReactComponent };